import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import i18n from '@/libs/i18n'
import VueThailandAddress from 'vue-thailand-address'
import Antd from 'ant-design-vue'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Api Address thailand
import 'vue-thailand-address/dist/vue-thailand-address.css'

import 'ant-design-vue/dist/antd.css'
import { FormSelectPlugin } from 'bootstrap-vue'
import { ButtonPlugin } from 'bootstrap-vue'
import { PaginationPlugin } from 'bootstrap-vue'
import { BadgePlugin } from 'bootstrap-vue'
import draggable from "vuedraggable";
import Ripple from 'vue-ripple-directive'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import Toast from 'vue-toastification'
Vue.config.productionTip = false

Vue.use(Vuetify)
Vue.directive('ripple', Ripple);
Vue.use(draggable)
Vue.use(BadgePlugin)
Vue.use(PaginationPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormSelectPlugin)


// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

Vue.use(VueThailandAddress)
// Composition API
Vue.use(VueCompositionAPI)

// Antd design
Vue.use(Antd)

Vue.use(Toast, {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
})

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

new Vue({
  router,
  store,
  i18n,
  vuetify: new Vuetify(),
  render: h => h(App),
}).$mount('#app')
